import { action } from "typesafe-actions"
import { Summary, SummaryActionTypes } from "./types"

export const fetchRequest = () => action(SummaryActionTypes.FETCH_REQUEST)
export const fetchSuccess = (data: Summary) => action(SummaryActionTypes.FETCH_SUCCESS, data)
export const fetchError = (message: string) => action(SummaryActionTypes.FETCH_ERROR, message)
